<div class="wrapper mb-2">
    <div class="row align-items-center">
        <img src="./assets/icons/arrow.svg">
        <span *ngIf="!isLote" class="section-title ml-2" >Produtos Concedidos: {{collaboratorName}}</span>
        <span *ngIf="isLote" class="section-title ml-2" >Conceder Produtos: {{colaboradoresId.length}} favorecidos</span>
    </div>
    <div class="my-4 alert alert-light" role="alert">
        <div class="row p-3">
            <div class="p-0 mx-3 align-self-center">
                <img src="../../../../../../assets/icons/logo_icon.svg" alt="" height="50px" class="">
            </div>
            <div class="col-11 p-0 m-0 align-self-center">
                <p class="m-0">
                    • Nesta tela você pode habilitar grupos ou produtos para este favorecido.
                    <br>
                    <!-- <br>Você pode navegar entre os produtos de incentivos ou de benefícios. -->
                    • Para selecionar o grupo (cesta de benefícios), selecione Benefícios. Se desejar habilitar produtos avulsos ou incentivos pontuais, selecione a opção outros produtos. 
                    <br>
                    • Os incentivos, se habilitados, permitem que o favorecido também possa realizar pagamentos com o PIX ou com o cartão Bankei. 
                </p>
            </div>
        </div>
    </div>
    <div class="row m-0 mt-3 justify-content-center">
        <mat-button-toggle-group  #group="matButtonToggleGroup" name="produtos" aria-label="Produtos" value="1">
            <mat-button-toggle value="1" (click)="tipobeneficio(1, true)">Benefícios</mat-button-toggle>
            <mat-button-toggle value="3" (click)="tipobeneficio(3)">Outros Produtos</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <nav class="mt-1">
        <div class="col p-0 text-right" *ngIf="group.value == '3'">
            <h6>Outros Produtos: Encontre-o através de uma das categorias</h6>
        </div>
        <div class="col p-0 text-left" *ngIf="group.value == '1'">
            <h6>Selecione uma cesta de benefícios (Grupo Flex)</h6>
        </div>
        <div class="nav nav-tabs " id="nav-tab" role="tablist">
            <ng-container *ngIf="group.value == '1'">
                <ng-container *ngFor="let item of productsCategory | productCategory: 1 : false">
                    <a class="nav-item nav-link" [ngClass]="{'active': tipoBeneficio == item.id}" id="nav-{{item.categoryAssignorLabel}}-tab" data-toggle="tab" href="#nav-{{item.categoryAssignorLabel}}" role="tab" attr.aria-controls="nav-{{item.categoryAssignorLabel}}" aria-selected="false" (click)="tipobeneficio(item.id)">
                        <!-- <input type="radio" id="{{item.id}}" name="{{item.id}}" value="{{item.id}}" [checked]="tipoBeneficio == item.id"> -->
                        {{item.categoryAssignorLabel}}
                    </a>
                </ng-container>
            </ng-container>
            <!-- Right tabs -->
            <ng-container *ngIf="group.value == '3'">
                <ng-container *ngFor="let item of productsCategory | productCategory: 3 : false">
                    <a class="nav-item nav-link" [ngClass]="{'ml-auto': item.id == 3, 'active': tipoBeneficio == item.id}" id="nav-{{item.categoryAssignorLabel}}-tab" data-toggle="tab" href="#nav-{{item.categoryAssignorLabel}}" role="tab" attr.aria-controls="nav-{{item.categoryAssignorLabel}}" aria-selected="false" (click)="tipobeneficio(item.id)">
                        {{item.categoryAssignorLabel}}
                    </a>
                </ng-container>
            </ng-container>
        </div>
    </nav>

    <ng-container id="myTabContent" *ngFor="let item of productsCategory | productCategory: tipoBeneficio : true">
        <div *ngIf="tipoBeneficio == item.id && item.id != 2" class="tab-content product-box px-5 py-5">
            <div class="col-lg-12 col-md-12 col-sm-12" *ngIf="isEmpty">
                <p class="text-center component-title my-5">{{messageErro}}</p>
            </div>
            <div class="tab-pane fade " [ngClass]="{'active':tipoBeneficio == item.id,'show':tipoBeneficio == item.id}" id="nav-{{item.categoryAssignorLabel}}" role="tabpanel" attr.aria-labelledby="nav-{{item.categoryAssignorLabel}}-tab">
                <div *ngIf="!cards || cards == [] || cards.length == 0" class="text-center px-5">
                    Não existem produtos de {{item.categoryAssignorLabel}} aderidos. Verifique através da opção do menu Produtos Disponíveis para a sua empresa.
                </div>
                <div class="row card-beneficio-tradicional">
                    <div class=" col-lg-4 col-md-6 col-sm-12" *ngFor="let item of cards; let i= index">
                        <div class="mx-2 mt-4 mb-5" [ngClass]=" {'divisao-col': i !== (cards.length - 1), 'divisao-col2': i == (cards.length -1)}">
                            <div class="custom-input-container form-check-inline my-4 col-12 mx-auto">
                                <input *ngIf="!isLote" [(ngModel)]="item.active" [attr.id]="item.assignorContractId"
                                    class="checkbox mx-2" type="checkbox" />

                                    <input *ngIf="isLote" [(ngModel)]="item.active" [attr.id]="item.assignorContractId"
                                    class="checkbox mx-2" type="checkbox" (click)="selectBatch(item, item.active)"/>

                                <label [attr.for]="item.assignorContractId"
                                    class="form-check-label font-weight-normal">{{item.productDescription}}
                                </label>
                            </div>
                            <div class="img-card mb-4">
                                <app-svg-card [color]="item.productColor" [icon]="item.productIcon" [name]="item.productDescription"></app-svg-card>
                            </div>
                            <!-- <label class="font-weight-normal" *ngIf="item.expirationDate">
                                Data de validade: {{ item.expirationDate | date: "dd/MM/yyyy" }}
                            </label> -->
                            <!--img [src]="'./assets/icons/produtos/icon-produtos/'+
                                    item.productGuid +'.svg'"
                                onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';"
                                class="img-card mb-4" alt="{{item.productDescription}}" /-->
                            <label *ngIf="item.expirated && !item.active" [attr.for]="item.expirated" class="vencido">
                                O cartão do favorecido está vencido. <br> Reative o cartão!
                            </label>
                            <div>
                                <div class="div-select-create custom-input-container">
                                    <select [disabled]="!item.isEditable" [(ngModel)]="item.regularityId" [attr.id]="i+regularidade"
                                        class="custom-input-outline">
                                        <option disabled value="">Selecione...</option>
                                        <option [value]="1">Mensal</option>
                                        <option [value]="2">Diário</option>
                                        <option [value]="3">Único</option>
                                    </select>
                                    <label class="custom-label-outline
                                        font-weight-normal" [attr.for]="i+regularidade">Regularidade:</label>
                                </div>
                                <div class="custom-input-container">
                                    <span>R$ </span>
                                    <input [readonly]="!item.isEditable" [(ngModel)]="item.referenceValue" class="custom-input-outline" type="number" min="0" />
                                </div>
                                <div class="text-center text-danger" *ngIf="erroValor || (item.active &&
                                    (item.referenceValue < 0) && grupoId == 0)">
                                    <p>Valor inválido.</p>
                                </div>
                                <!-- <div class="custom-input-container form-check-inline my-4 col-12 mx-auto">
                                    <input [(ngModel)]="item.suspended" [attr.id]="item.productGuid"
                                        class="checkbox mx-2" type="checkbox" />

                                    <label [attr.for]="item.productGuid"
                                        class="form-check-label font-weight-normal">Suspender {{item.productDescription}}
                                    </label>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="tipoBeneficio == item.id && item.id == 2" class="tab-content product-box px-5 py-5">
            <div class="col-lg-12 col-md-12 col-sm-12" *ngIf="isEmpty" style="min-height: 5vh;">
                <p class="text-center component-title my-5">{{messageErro}}</p>
            </div>
            <div class="tab-pane fade" [ngClass]="{'active':tipoBeneficio == item.id,'show':tipoBeneficio == item.id}" id="nav-{{item.categoryAssignorLabel}}" role="tabpanel" attr.aria-labelledby="nav-{{item.categoryAssignorLabel}}-tab">
                <ng-container class="row">
                    <div *ngIf="exibirCadastroFlex" class="col-12">
                        <div class="mx-2 mb-5">
                            <div class="custom-input-container form-check-inline my-4 col-12 mx-auto">
                                <label [attr.for]="cardFlex.assignorContractId"
                                    class="form-check-label font-weight-normal">
                                    <div class="img-card mb-5">
                                        <app-svg-card [color]="cardFlex.productColor" [icon]="cardFlex.productIcon" [name]="cardFlex.productDescription"></app-svg-card>
                                    </div>
                                    <!--img [src]="'./assets/icons/produtos/icon-produtos/'+
                                    cardFlex.productGuid +'.svg'"
                                        onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';"
                                        class="img-card mb-5" alt="{{cardFlex.productDescription}}" /-->
                                </label>

                                <div class = "selecao-grupo" style="width: 100%; margin-left: 20px;">
                                    <h2>Grupo</h2>
                                    <mat-form-field appearance="fill" class="w-100" *ngIf="groups.length != 0">
                                        <mat-label>Selecione o grupo</mat-label>
                                        <mat-select  [formControl]="groupsCtrl" id="groups"  (selectionChange)="onItemSelect($event.value)">
                                            <mat-option [value]="null">Nenhum</mat-option>
                                            <mat-option *ngFor="let item of groups" [value]="item.id" >
                                                {{item.name}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field appearance="fill" class="w-100" *ngIf="groups.length == 0">
                                        <mat-label>Selecione o grupo</mat-label>
                                        <mat-select  id="groupCreate"  (selectionChange)="criarGrupo($event)">
                                            <mat-option class="link-criar-grupo" value="criar">
                                                Para criar incentivos flexíveis é necessário antes cadastrar um grupo. Cadastre Agora!
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <div class="row">
                                        <div class="produto-flex-grupo" *ngIf="productFlexGroup">
                                            <h6>Regularidade: </h6>
                                            <span *ngIf="productFlexGroup.standardPeriodCard === 1" class="benefit-data">Mensal</span>
                                            <span *ngIf="productFlexGroup.standardPeriodCard === 2" class="benefit-data">Diário</span>
                                        </div>
                                        <div class="produto-flex-grupo" *ngIf="productFlexGroup">
                                            <h6>Valor: </h6>
                                            <label>{{productFlexGroup.value | currency: 'R$'}}</label>
                                        </div>
                                        <div class="produto-flex-grupo" *ngIf="!productFlexGroup">
                                            <h6>Regularidade: </h6>
                                            <label>Selecione um grupo</label>
                                        </div>
                                        <div class="produto-flex-grupo" *ngIf="!productFlexGroup">
                                            <h6>Valor: </h6>
                                            <label>Selecione um grupo</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class = "row coluna-produtos-grupo">
                                <div *ngFor="let item of productsByGroup" class="align-center col-lg-4 col-md-6 col-sm-12 mt-2" >
                                    <div class="mr-4 img-card">
                                        <app-svg-card [color]="item.productColor" [icon]="item.productIcon" [name]="item.productName"></app-svg-card>
                                    </div>
                                    <!--img class="mr-4 img-card" src="./assets/icons/produtos/icon-produtos/{{item.productGuid}}.svg" onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';"-->

                                    <div class="row-mobile">
                                        <label class="benefit-data produtos-grupo" >Regularidade:</label>
                                        <span *ngIf="item.standardPeriodCard === 1" class="benefit-data">Mensal</span>
                                        <span *ngIf="item.standardPeriodCard === 2" class="benefit-data">Diário</span>
                                        <div class="dot"></div>
                                    </div>
                                    <div class="row-mobile">
                                        <label class="benefit-data produtos-grupo" >Valor:</label>
                                        <div class="benefit-data">{{ item.value | currency: 'R$' }}</div>
                                    </div>
                                    <label *ngIf="item.expirated && !item.active" [attr.for]="item.expirated" class="vencido">
                                        O cartão do favorecido está vencido. <br> Reative o cartão!
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!exibirCadastroFlex" class="col-12">

                        <div class="mx-2 mb-5">
                            <div class="row" style="place-content: center;">
                                <label [attr.for]="cardFlex.assignorContractId"
                                    class="form-check-label font-weight-normal">
                                    <div class="img-card-flex-solo mb-5 col-12">
                                        <app-svg-card [color]="cardFlex.productColor" [icon]="cardFlex.productIcon" [name]="cardFlex.productDescription"></app-svg-card>
                                    </div>
                                    <!--img [src]="'./assets/icons/produtos/icon-produtos/'+
                                        cardFlex.productGuid +'.svg'"
                                        onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';"
                                        class="img-card-flex-solo mb-5 col-12" alt="{{cardFlex.productDescription}}" /-->
                                </label>
                                <div class="col-12" style="
                                text-align-last: center;">
                                    <label class="nao-possui-flex-text col-12">Poxa, você ainda não aderiu ao produto flex...</label>
                                    <span class="link-beneficios "(click)="aderirBeneficios()"> Clique aqui para aderir </span>

                                </div>
                            </div>

                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="product-box px-5 py-5 container-fluid ">
            <div class="row button-container mt-5">
                <div class="col-6 text-left">
                    <button type="button" class="custom-button-previous" (click)="previous()">
                        VOLTAR
                    </button>
                </div>
                <div class="col-6 text-right">
                    <button type="button" class="custom-button-full"
                        (click)="onSubmit(confirmModal)">
                        CONCLUIR
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<!--ConfirmModal-->
<ng-template #confirmModal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">Remover favorecido do grupo flex</h5>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <div class="clean-modal-text">
            <p class="text-center">
                Ao atribuir o(s) benefício(s) selecionado(s), o favorecido será removido do grupo Flex
               <br>Deseja continuar?
            </p>
        </div>
    </div>
    <div class="col-12 modal-footer clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-modal-button" (click)="onSubmit(null,true);modal.dismiss('Close click')">
            Confirmar
        </button>
    </div>
</ng-template>
